function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { PadMarg } from './../../enhancers';
import css from './Section.sass';

function BaseSection(props) {
  var children = props.children,
      color = props.color,
      className = props.className,
      textAlign = props.textAlign;
  var classNames = cx(css.root, color && css["color-".concat(color)], textAlign && css[textAlign], className);
  return React.createElement("div", {
    className: classNames
  }, children);
}

BaseSection.displayName = 'Paper.Section';
BaseSection.propTypes = {
  /**
   * Custom class name
   */
  className: PropTypes.string,

  /**
   * Section content
   */
  children: PropTypes.node,

  /**
   * Section color
   */
  color:
  /*#__PURE__*/
  PropTypes.oneOf(['red', 'green', 'blue', 'grey', 'white']),

  /**
   * Text align
   */
  textAlign:
  /*#__PURE__*/
  PropTypes.oneOf(['left', 'right', 'center'])
};

var Section = function Section(props) {
  return React.createElement(PadMarg, _extends({
    InputComponent: BaseSection
  }, props));
};

Section.defaultProps = {};
export { Section };